<template>
  <SOSlotModal
      :modal-id="id"
      modal-title="Berhasil Menambah Mesin"
      @close="close"
  >
    <template v-slot:modal-body>
      <div class="f-16"><b>{{ namaMesin }}</b> berhasil ditambahkan</div>
      <div class="f-16 m-t-12">
        Download QR Code, cetak, lalu tempelkan ke mesin Anda untuk mulai menggunakan SnapBridge.
      </div>
    </template>
    <template v-slot:modal-footer>
      <div class="button-wrapper-inset-berhasil">
        <SOButton
            :primary="true"
            :full="true"
            text="Download QR Code"
            @action="download"
        />
        <SOButton
            :outline="true"
            :full="true"
            text="Nanti Saja"
            @action="$emit('back')"
        />
      </div>
    </template>
  </SOSlotModal>
</template>

<script>
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOButton from "@/so-components/global/ui/SOButton";
import VueQr from "vue-qr-generator"

export default {
  name: "SnapMesinModalInsertBerhasil",
  components: {SOButton, SOSlotModal, VueQr},
  props: {
    namaMesin: String,
    qr: String
  },
  data() {
    return {
      id: "modal-insert-berhasil"
    }
  },
  methods: {
    close() {
      $("#" + this.id).modal("hide");
      setTimeout(() => {
        this.$emit("close")
      }, 500)
    },

    download() {
      const link = document.createElement('a')
      link.href = "https://central-kube.smartlink.id/qr/download/" + this.qr + "?caption=" + this.namaMesin + "&name=QRIS_" + this.namaMesin + ".png"
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  },
  mounted() {
    $("#" + this.id).modal("show")
  }
}
</script>

<style scoped>

</style>